import { render, staticRenderFns } from "./candidate-table.vue?vue&type=template&id=613d6ae6&scoped=true"
import script from "./candidate-table.vue?vue&type=script&lang=ts"
export * from "./candidate-table.vue?vue&type=script&lang=ts"
import style0 from "./candidate-table.vue?vue&type=style&index=0&id=613d6ae6&prod&lang=scss"
import style1 from "./candidate-table.vue?vue&type=style&index=1&id=613d6ae6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613d6ae6",
  null
  
)

export default component.exports